import { Phone, Map } from "lucide-react";
import { useLanguage } from "./LanguageContext";
import { translations } from "./translations";

export const Menus = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return [
    {
      id: 1,
      name: t.home,
      url: "/",
    },
    {
      name: t.ourProjects,
      subMenuHeading: [t.projects],
      subMenu: [
        {
          id: 2,
          name: t.thanlyin,
          icon: Map,
          url: "/project",
        },
      ],
      gridCols: 1,
    },
    {
      id: 3,
      name: t.aboutUs,
      url: "/about-us",
    },
    {
      id: 4,
      name: t.contact,
      icon: Phone,
      url: "/contact",
    },
  ];
};
